import { fill } from 'lodash';

import { type AccountMetrics, MetricType, type Subscription, type SubscriptionUsage } from '../model';

import { summarizeSubscriptionUsage } from './BillingLimitRow';

type OveragesProps = Readonly<{
  subscriptionUsage: SubscriptionUsage | null;
  subscription: Subscription | null;
}>;

export const Overages = ({ subscriptionUsage, subscription }: OveragesProps) => {
  const renderUsage = (accountMetrics: AccountMetrics, activeSubscription: Subscription) => [
    {
      usage: accountMetrics[MetricType.SEATS],
      limit: activeSubscription._limits[MetricType.SEATS],
    },
    {
      usage: accountMetrics[MetricType.MONTHLY_ACTIVE_USERS],
      limit: activeSubscription._limits[MetricType.MONTHLY_ACTIVE_USERS],
    },
    {
      usage: accountMetrics[MetricType.EVENTS_PUBLISHED],
      limit: activeSubscription._limits[MetricType.EVENTS_PUBLISHED],
    },
    {
      usage: accountMetrics[MetricType.EVENTS_RECEIVED],
      limit: activeSubscription._limits[MetricType.EVENTS_RECEIVED],
    },
  ];
  if (!subscriptionUsage || !subscription) {
    return (
      <>
        {fill(Array(4), 2).map((_, i) => (
          <td key={i}>loading</td>
        ))}
      </>
    );
  }
  const overages = renderUsage(subscriptionUsage._usage, subscription);
  return (
    <>
      {overages.map((d: { usage: number; limit: number }, i) => (
        <td key={i}>{d.limit === 0 ? 'N/A' : summarizeSubscriptionUsage(d.usage, d.limit)}</td>
      ))}
    </>
  );
};
